import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { getYearFromTimestamp } from '../../../utils/timestamp';
import Icon from '../../../components/Icon';
import messages from './messages';
import setStudyOptionsLabels from './mapping';
import './styles.css';

class StudyOptions extends React.PureComponent {
  renderHeader = () => {
    return (
      <>
        <h2 className="title" data-cy="studies-study-options-title">
          <FormattedMessage {...messages.title} />
        </h2>
        <div className="subtitle" data-cy="studies-study-options-subtitle-1">
          <FormattedMessage {...messages.subtitle1} />
        </div>
        <div className="subtitle" data-cy="studies-study-options-subtitle-2">
          <FormattedMessage {...messages.subtitle2} />
        </div>
        <div className="divider" />
      </>
    );
  };

  renderOptions = () => {
    const studyOptions = setStudyOptionsLabels(this.props.studyOptions);
    const activeStyle = option => (option.value ? 'active' : 'inactive');
    return (
      <div className="options" data-cy="studies-study-options-list">
        {Object.keys(studyOptions)
          .sort((k1, k2) => k1.localeCompare(k2))
          .map(key => (
            <div className={`option ${activeStyle(studyOptions[key])}`} key={key}>
              {studyOptions[key].value && <Icon className="check-icon" name="check" />}
              {!studyOptions[key].value && <Icon className="close-icon" name="close" />}
              <FormattedMessage {...studyOptions[key].label} />
            </div>
          ))}
      </div>
    );
  };

  renderFooter = () => {
    const lastUpdated = getYearFromTimestamp(this.props.lastUpdated);
    return (
      <div className="footer">
        <FormattedMessage values={{ lastUpdated }} {...messages.footer} />
      </div>
    );
  };

  render() {
    return (
      <div id="studies-study-options">
        <div className="common-core-width container">
          {this.renderHeader()}
          {this.renderOptions()}
          {this.renderFooter()}
        </div>
      </div>
    );
  }
}

export default injectIntl(StudyOptions);
